import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { MakeListComponent } from './components/list/make-list.component';

export class MakeRoutingStates {
  public static readonly LIST = {
    url: 'make'
  };
}

export const MakeRoutes: Routes = [
  {
    path: MakeRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Make List'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR, Groups.ASSET_VIEWER]
    },
    component: MakeListComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(MakeRoutes)]
})
export class MakeRoutingModule {}
